import BudgetFilters from "@app/components/budget-filters.tsx";
import BudgetTable from "@app/components/budget-table.tsx";
import { Route } from "@app/routes/_authenticated/_manager/assignment/$assignmentId.tsx";
import { assignmentBudgetFiltersStore } from "@app/stores/filters.store.ts";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Tab } from "@mui/material";
import { useNavigate } from "@tanstack/react-router";
import { useStore } from "@tanstack/react-store";
import { useEffect, useState } from "react";

interface Props {
    id: number;
}

export default function AssignmentBudgetForm({ id }: Props) {
    const search = Route.useSearch();
    const [activeTab, setActiveTab] = useState(search.tab2 ?? "time");

    const filters = useStore(assignmentBudgetFiltersStore(id));

    const navigate = useNavigate();

    const handleChangeTab = (tab: string) => {
        setActiveTab(tab);
        void navigate({ to: ".", search: { ...search, tab2: tab } });
    };

    useEffect(() => {
        assignmentBudgetFiltersStore(id).setState(() => ({ ...filters, assignmentId: id }));
    }, [id]);

    return (
        <>
            <BudgetFilters
                assignmentId={id}
                filters={filters}
                setFilters={(value) => assignmentBudgetFiltersStore(id).setState(() => value)}
                rateType={filters.rateType}
                setRateType={(value) =>
                    assignmentBudgetFiltersStore(id).setState(() => ({ ...filters, rateType: value }))
                }
            />
            <TabContext value={activeTab}>
                <TabList onChange={(_e, value) => handleChangeTab(value)}>
                    <Tab value={"time"} label={"Time"} />
                    <Tab value={"travel"} label={"Travel Expenses"} />
                    <Tab value={"other"} label={"Other Individual Expenses"} />
                    <Tab value={"office"} label={"Office Expenses"} />
                </TabList>
                <TabPanel value={"time"}>
                    <BudgetTable catId={1} filters={filters} rateType={filters.rateType} assignmentId={id} />
                </TabPanel>
                <TabPanel value={"travel"}>
                    <BudgetTable catId={2} filters={filters} rateType={filters.rateType} assignmentId={id} />
                </TabPanel>
                <TabPanel value={"other"}>
                    <BudgetTable catId={3} filters={filters} rateType={filters.rateType} assignmentId={id} />
                </TabPanel>
                <TabPanel value={"office"}>
                    <BudgetTable catId={4} filters={filters} rateType={filters.rateType} assignmentId={id} />
                </TabPanel>
            </TabContext>
        </>
    );
}
